import React, { useEffect, useState } from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import AppRouter from "./AppRouter";
import theme from "./styles/theme";
import { AuthProvider, useAuth } from "./firebase";
import { SnackbarProvider } from "notistack";
import { ShoppingCartProvider } from "./pages/Checkout/ShoppingCartProvider";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import "./utils/createSampleData"; // Import sample data utilities

const PAYPAL_CLIENT_ID =
  "AeB0DEgvouk__LP-KAEf4Viymbt5XGhfkuh07aJam3z0nztmDDOpy7i40U1r8gSic6VRpBeCSHFKJb61";

const App: React.FC = () => {
  return (
    <div className="App" data-testid="app">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <ShoppingCartProvider>
            <SnackbarProvider maxSnack={3}>
              <PayPalScriptProvider options={{ clientId: PAYPAL_CLIENT_ID }}>
                <AppRouter />
              </PayPalScriptProvider>
            </SnackbarProvider>
          </ShoppingCartProvider>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
};

export default App;
